/**
 * JUWARI: 未ログイン（ゲスト）訪問者向け LINE連携案内
 *
 * 動作
 *   - 一定時間後に吹き出しを自動表示する。
 *   - 吹き出しの閉じるボタンで吹き出しだけを閉じる。丸アイコンは常に残る。
 *   - 丸アイコン / 吹き出しを押すと案内パネルを開く（保存期間中でも開ける）。
 *   - 閉じた状態は localStorage に「再表示しない期限（エポックミリ秒）」だけを保存する。
 *     個人情報は一切保存しない。
 *   - ESC / パネル外クリックでパネルを閉じ、フォーカスを丸アイコンへ戻す。
 *   - テーマエディタ（design mode）では保存状態と表示遅延を無視して即表示する。
 *
 * このスクリプトが読み込まれなかった場合、丸アイコンは
 * routes.account_login_url への通常のリンクとして機能する（フォールバック）。
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'juwari_glg_bubble_hidden_until';
  var DAY_MS = 24 * 60 * 60 * 1000;

  var root = document.querySelector('[data-juwari-glg]');
  if (!root) return;

  var bubble = root.querySelector('[data-glg-bubble]');
  var bubbleLink = root.querySelector('[data-glg-bubble-link]');
  var bubbleClose = root.querySelector('[data-glg-bubble-close]');
  var panel = root.querySelector('[data-glg-panel]');
  var panelClose = root.querySelector('[data-glg-panel-close]');
  var fab = root.querySelector('[data-glg-fab]');

  if (!bubble || !bubbleLink || !bubbleClose || !panel || !panelClose || !fab) return;

  var designMode = root.dataset.designMode === 'true';
  var delayMs = clampNumber(parseInt(root.dataset.delayMs, 10), 0, 60000, 3000);
  var dismissDays = clampNumber(parseInt(root.dataset.dismissDays, 10), 1, 365, 7);

  var bubbleTimer = null;

  function clampNumber(value, min, max, fallback) {
    if (typeof value !== 'number' || isNaN(value)) return fallback;
    return Math.min(Math.max(value, min), max);
  }

  // localStorage は Safari の設定等で例外を投げることがあるため、常に握りつぶす。
  function readHiddenUntil() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = parseInt(raw, 10);
      return isNaN(parsed) ? 0 : parsed;
    } catch (error) {
      return 0;
    }
  }

  function writeHiddenUntil(timestamp) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(timestamp));
    } catch (error) {
      /* 保存できなくても表示自体は継続する */
    }
  }

  function isBubbleSuppressed() {
    if (designMode) return false;
    return Date.now() < readHiddenUntil();
  }

  function showBubble() {
    if (isPanelOpen() || !bubble.hidden) return;
    bubble.hidden = false;
  }

  function hideBubble(persist) {
    if (bubbleTimer !== null) {
      window.clearTimeout(bubbleTimer);
      bubbleTimer = null;
    }
    bubble.hidden = true;
    if (persist && !designMode) {
      writeHiddenUntil(Date.now() + dismissDays * DAY_MS);
    }
  }

  function isPanelOpen() {
    return !panel.hidden;
  }

  function openPanel() {
    if (isPanelOpen()) return;
    hideBubble(false);
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    panelClose.focus();
  }

  function closePanel(returnFocus) {
    if (!isPanelOpen()) return;
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    if (returnFocus) fab.focus();
  }

  function togglePanel() {
    if (isPanelOpen()) {
      closePanel(true);
    } else {
      openPanel();
    }
  }

  // --- 初期化 -------------------------------------------------------------

  // JS が動作していることを示す。閉じるボタンはこのクラスが付いて初めて表示される。
  root.classList.add('juwari-glg--ready');

  // JS が動作している場合のみ、アイコンと吹き出しを「パネルを開くボタン」に格上げする。
  // href は残したままなので、スクリプトが途中で失敗しても遷移先は失われない。
  [fab, bubbleLink].forEach(function (element) {
    element.setAttribute('role', 'button');
    element.setAttribute('aria-controls', panel.id);
    element.setAttribute('aria-expanded', 'false');
  });

  function onActivate(event) {
    event.preventDefault();
    togglePanel();
  }

  fab.addEventListener('click', onActivate);
  bubbleLink.addEventListener('click', onActivate);

  // role="button" として扱うため、Space キーでも起動できるようにする
  // （Enter はリンク・ボタンとも既定で click を発火する）。
  [fab, bubbleLink].forEach(function (element) {
    element.addEventListener('keydown', function (event) {
      if (event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        togglePanel();
      }
    });
  });

  bubbleClose.addEventListener('click', function () {
    hideBubble(true);
    fab.focus();
  });

  panelClose.addEventListener('click', function () {
    closePanel(true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (isPanelOpen()) {
      closePanel(true);
    } else if (!bubble.hidden) {
      hideBubble(true);
    }
  });

  // パネル外をクリックしたら閉じる（モーダルではないためフォーカストラップは行わない）
  document.addEventListener('click', function (event) {
    if (!isPanelOpen()) return;
    if (root.contains(event.target)) return;
    closePanel(false);
  });

  // --- 吹き出しの自動表示 --------------------------------------------------

  if (designMode) {
    // テーマエディタでは保存状態も遅延も無視して、すぐにデザインを確認できるようにする。
    showBubble();
  } else if (!isBubbleSuppressed()) {
    if (delayMs === 0) {
      showBubble();
    } else {
      bubbleTimer = window.setTimeout(showBubble, delayMs);
    }
  }
})();
